import React from 'react';
import cn from 'classnames';
import { generatePath, useHistory } from 'react-router';

import { IModel } from 'models/company/interface';

import { setPopup } from 'client/redux/ui';
import { imgixUrl } from 'client/utils/imgix-url';
import { selectLang } from 'client/redux/settings/selectors';
import { useAppDispatch, useAppSelector } from 'client/hooks';
import { COMPANY_TEAM_MEMBER_PAGE_ROUTE } from 'client/constants/routes';

import noAvatarImageUrl from 'client/assets/default-avatar.svg';

import css from './Founder.module.scss';

interface Props {
  companyId: string;
  className?: string;
  data: IModel['team'][number];
}

function Founder(props: Props) {
  const { data, companyId, className = '' } = props;
  const history = useHistory();
  const lang = useAppSelector(selectLang);
  const dispatch = useAppDispatch();

  const onPersonClick = () => {
    history.push(generatePath(COMPANY_TEAM_MEMBER_PAGE_ROUTE, { id: companyId, slug: data.slug, lang }));
    dispatch(setPopup(null));
  };

  return (
    <div
      className={cn(css.founder, className)}
      role={data.slug ? 'link' : 'none'}
      onClick={data.slug ? onPersonClick : undefined}
    >
      <div
        className={css.founderPhoto}
        style={{
          backgroundImage: `url(${
            data.avatar
              ? imgixUrl(data.avatar, {
                  q: 85,
                  auto: 'compress',
                  fit: 'fill',
                  'max-w': 200,
                })
              : noAvatarImageUrl
          })`,
        }}
      />
      <div className={css.founderInfo}>
        <p className={css.founderName}>{data.name}</p>
        <p className={css.founderRole}>{data.role}</p>
      </div>
    </div>
  );
}

export { Founder };
export default Founder;
